"use strict";
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments)).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t;
    return { next: verb(0), "throw": verb(1), "return": verb(2) };
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var amazon_cognito_identity_js_1 = require("amazon-cognito-identity-js");
var aws_sdk_1 = require("aws-sdk");
var Axios = require("axios");
var Cookie = require("js-cookie");
/**
 * # セッション
 */
var Session;
(function (Session) {
    // セッションIDのcookie保存名
    var SessionIdCookieName = '__adminapi_session_id';
    // セッショントークンのcookie保存名
    var SessionTokenCookieName = '__adminapi_session_token';
    // ユーザ名のcookie保存名
    var SessionUserNameCookieName = '__adminapi_session_name';
    // ユーザ名のcookie保存名
    var SessionGadgetCookieName = '__adminapi_session_gadget';
    // AdminAPIへの接続情報
    var URL = {
        new: { method: 'get', url: '/sessions/new.json' },
        create: { method: 'post', url: '/sessions.json' },
        get: { method: 'get', url: '/sessions/' },
    };
    /**
     * ## セッション関連のエラー
     */
    var SessionError = (function () {
        function SessionError(message) {
            this.message = message;
            this.name = 'SessionError';
            this.support = '何度か試しても失敗する場合は<a href="https://ekiworld.net/contact/enterprize_after.html" target="_blank">お問い合わせフォーム</a>よりご連絡ください。';
        }
        SessionError.prototype.toString = function () {
            return this.name + ': ' + this.message + this.support;
        };
        return SessionError;
    }());
    /**
     * ## セッション関係のサーバエラー
     */
    var ServerError = (function (_super) {
        __extends(ServerError, _super);
        function ServerError() {
            var _this = _super.apply(this, arguments) || this;
            _this.name = 'ServerError';
            return _this;
        }
        return ServerError;
    }(SessionError));
    Session.ServerError = ServerError;
    /**
     * ## セッション関係のクライアントエラー
     */
    var ClientError = (function (_super) {
        __extends(ClientError, _super);
        function ClientError(message) {
            var _this = _super.call(this, message) || this;
            _this.name = 'ClientError';
            _this.support = '';
            return _this;
        }
        return ClientError;
    }(SessionError));
    Session.ClientError = ClientError;
    /**
     * ## セッション生成時の認証エラー
     */
    var AuthenticationError = (function (_super) {
        __extends(AuthenticationError, _super);
        function AuthenticationError() {
            var _this = _super.apply(this, arguments) || this;
            _this.name = 'AuthenticationError';
            return _this;
        }
        return AuthenticationError;
    }(ClientError));
    Session.AuthenticationError = AuthenticationError;
    /**
     * ## セッションを取り扱うクラス
     */
    var Client = (function () {
        /**
         * コンストラクタ
         * @param setting AdminAPIとAWSへの接続情報
         */
        function Client(setting) {
            // セッション取得用リクエストヘッダ
            this._headers = undefined;
            // セッション取得用情報取得のリトライ数
            this._retry = 0;
            // エラーメッセージ
            this._errorMessage = '';
            this._setting = setting;
            if (this._setting.retryMax === undefined) {
                this._setting.retryMax = 5;
            }
            this._agent = Axios.create({
                baseURL: this._setting.baseURL,
                withCredentials: true,
                responseType: 'json',
            });
            aws_sdk_1.config.update({
                region: setting.aws.region,
                credentials: new aws_sdk_1.CognitoIdentityCredentials({
                    IdentityPoolId: setting.aws.identityPoolId,
                }),
            });
            this._userPool = new amazon_cognito_identity_js_1.CognitoUserPool({
                UserPoolId: setting.aws.userPoolId,
                ClientId: setting.aws.clientId,
            });
            this.getEditData();
        }
        Object.defineProperty(Client.prototype, "baseURL", {
            // 設定されているAdminAPIのURLのベース部分
            get: function () { return this._setting.baseURL; },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(Client.prototype, "retryMax", {
            // 設定されているAdminAPIへのリトライ数の最大値
            get: function () { return this._setting.retryMax; },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(Client.prototype, "submittable", {
            // セッション生成APIにsubmit可能かどうか
            get: function () { return this._headers !== undefined; },
            enumerable: true,
            configurable: true
        });
        /**
         * ### セッションの生成
         * ユーザ認証やセッション情報の保存まで行います。
         * @param userName ユーザ名
         * @param password パスワード
         * @return 生成したら次の処理を呼び出すPromiseオブジェクトを返します。
         */
        Client.prototype.create = function (userName, password) {
            var _this = this;
            return Promise.all([
                this.authenticate(userName, password),
                new Promise(function (resolv) { return __awaiter(_this, void 0, void 0, function () {
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                if (!!this.submittable)
                                    return [3 /*break*/, 2];
                                return [4 /*yield*/, this.sleep()];
                            case 1:
                                _a.sent();
                                if (this._retry > this.retryMax) {
                                    throw new SessionError(this._errorMessage);
                                }
                                return [3 /*break*/, 0];
                            case 2:
                                resolv();
                                return [2 /*return*/];
                        }
                    });
                }); }),
            ]).then(function (result) {
                return _this.submit(userName, result[0].getAccessToken().getJwtToken(), result[0].getIdToken().getJwtToken());
            });
        };
        /**
         * ### 組織情報の取得
         */
        Client.prototype.getSessionTokenOrganization = function () {
            return this.sessionToken()[0];
        };
        /**
         * ### ユーザ名の取得
         */
        Client.prototype.getUserName = function () {
            return new Promise(function (resolv) {
                // 本当はAPI経由で取得したい
                resolv(Cookie.get(SessionUserNameCookieName));
            });
        };
        /**
         * ### ガジェットの設定を取得
         */
        Client.prototype.getGadgetSetting = function (name) {
            return new Promise(function (resolv) {
                var getGadgetSetting = Cookie.getJSON(SessionGadgetCookieName);
                resolv(getGadgetSetting ? getGadgetSetting[name] : undefined);
            });
        };
        // 認証情報取得関数
        Client.prototype.getAuthenticationData = function () {
            var _this = this;
            var sessionId = this.sessionId();
            if (sessionId === undefined) {
                // セッションIDが無かったら強制ログアウト
                alert('セッションが切れました。再ログインをお願いします。');
                this.logout(true);
            }
            var tokens = this.sessionToken();
            var key = null;
            var sig = null;
            if (tokens) {
                var token = tokens[0]; // とりあえず最初を使う
                if (token) {
                    key = token['apiKey'];
                    sig = token['token'];
                }
            }
            return new Promise(function (resolv) {
                if (key !== null && sig !== null) {
                    resolv({ key: key, sig: sig });
                }
                else {
                    var request = URL['get'];
                    request.url = request.url + sessionId + '.json';
                    _this._agent.request(request).then(function (res) {
                        var resultSet = res.data['resultSet'];
                        if (resultSet === undefined) {
                            throw _this.sessionResponseError('resultSet');
                        }
                        if (resultSet.session === undefined) {
                            throw _this.sessionResponseError('session');
                        }
                        _this.save(resultSet.session);
                        var newTokens = _this.sessionToken();
                        if (newTokens) {
                            var token = newTokens[0]; // とりあえず最初を使う
                            if (token) {
                                key = token['apiKey'];
                                sig = token['token'];
                            }
                        }
                        if (key !== undefined || sig !== undefined) {
                            resolv({ key: key, sig: sig });
                        }
                        else {
                            throw new SessionError('Tokenの取得に失敗しました。');
                        }
                    }).catch(function (err) { return __awaiter(_this, void 0, void 0, function () {
                        return __generator(this, function (_a) {
                            if (err.response) {
                                if (err.response.status === 403) {
                                    alert('セッションが切れました。再ログインをお願いします。');
                                    // （セッション切れ）の場合は強制ログアウト
                                    this.logout(true);
                                }
                                else {
                                    console.error({
                                        status: err.response.status,
                                        body: err.response.data,
                                    });
                                    throw new ServerError(err.response.data);
                                }
                            }
                            else {
                                console.log('Error', err.message);
                                throw new ServerError(err.message);
                            }
                            return [2 /*return*/];
                        });
                    }); });
                }
            });
        };
        /**
         * ### ログアウト
         * @param cookieOnly trueの場合、Cookieに保存してあるセッションIDを破棄するだけで、サーバ側のセッション情報は破棄しない
         */
        Client.prototype.logout = function (cookieOnly) {
            var _this = this;
            var logoutSession = (function () {
                Cookie.set(SessionIdCookieName, null, { path: '/' });
                Cookie.set(SessionUserNameCookieName, null, { path: '/' });
                Cookie.set(SessionTokenCookieName, null, { path: '/' });
                window.location.href = 'login.html';
            });
            var sessionId = this.sessionId();
            if (sessionId == null || cookieOnly) {
                logoutSession();
            }
            else {
                this.getAuthenticationData()
                    .then(function (res) {
                    var urlId = { method: 'delete', url: '/sessions/' + sessionId + '.http' };
                    _this._agent.request(Object.assign({}, urlId, {
                        headers: _this._headers,
                        params: res,
                    }))
                        .then(function () {
                        logoutSession();
                    })
                        .catch(function (err) { return __awaiter(_this, void 0, void 0, function () {
                        return __generator(this, function (_a) {
                            logoutSession();
                            return [2 /*return*/];
                        });
                    }); });
                });
            }
        };
        /**
         * ### パスワード再設定用のメールを送る
         */
        Client.prototype.sendMailForPasswordReset = function (userName) {
            var userData = { Username: userName, Pool: this._userPool };
            var cognitoUser = new amazon_cognito_identity_js_1.CognitoUser(userData);
            return new Promise(function (resolv, reject) {
                cognitoUser.forgotPassword({
                    onSuccess: function () { resolv(); },
                    onFailure: function (err) {
                        var message = "\u30E1\u30FC\u30EB\u3092\u9001\u4FE1\u3067\u304D\u307E\u305B\u3093\u3067\u3057\u305F\u3002( " + err + " )";
                        if (err.statusCode === 400) {
                            reject(new ClientError(message));
                        }
                        else {
                            reject(new ServerError(message));
                        }
                    },
                });
            });
        };
        /**
         * ### パスワードを再設定する
         */
        Client.prototype.resetPassword = function (userName, password, code) {
            var userData = { Username: userName, Pool: this._userPool };
            var cognitoUser = new amazon_cognito_identity_js_1.CognitoUser(userData);
            return new Promise(function (resolv, reject) {
                cognitoUser.confirmPassword(code, password, {
                    onSuccess: function () { resolv(); },
                    onFailure: function (err) {
                        var message = "\u30D1\u30B9\u30EF\u30FC\u30C9\u3092\u5909\u66F4\u3067\u304D\u307E\u305B\u3093\u3067\u3057\u305F\u3002( " + err + " )";
                        if (err.statusCode === 400) {
                            reject(new ClientError(message));
                        }
                        else {
                            reject(new ServerError(message));
                        }
                    },
                });
            });
        };
        /**
         * ### パスワードを変更する
         */
        Client.prototype.changePassword = function (userName, oldPassword, password) {
            var authData = { Username: userName, Password: oldPassword };
            var authDetails = new amazon_cognito_identity_js_1.AuthenticationDetails(authData);
            var userData = { Username: userName, Pool: this._userPool };
            var cognitoUser = new amazon_cognito_identity_js_1.CognitoUser(userData);
            return new Promise(function (resolv, reject) {
                cognitoUser.authenticateUser(authDetails, {
                    onSuccess: function (result) {
                        cognitoUser.changePassword(oldPassword, password, function (err) {
                            if (err) {
                                reject(new ClientError("\u30D1\u30B9\u30EF\u30FC\u30C9\u3092\u5909\u66F4\u3067\u304D\u307E\u305B\u3093\u3067\u3057\u305F\u3002( " + err + " )"));
                            }
                            else {
                                resolv();
                            }
                        });
                    },
                    onFailure: function (err) {
                        if (err.statusCode === 400) {
                            reject(new AuthenticationError('現在のパスワードが違います。'));
                        }
                        else {
                            reject(new ServerError('認証サーバに接続できませんでした。'));
                        }
                    },
                });
            });
        };
        /**
         * ### メールアドレスの検証を行う
         */
        Client.prototype.confirmRegistration = function (userName, code) {
            var userData = { Username: userName, Pool: this._userPool };
            var cognitoUser = new amazon_cognito_identity_js_1.CognitoUser(userData);
            return new Promise(function (resolv, reject) {
                cognitoUser.confirmRegistration(code, true, function (err) {
                    if (err) {
                        var message = '検証に失敗しました。入力された検証コードを確認してください。 検証コードが有効期限切れの場合は、再発行してください。';
                        if (err.statusCode === 400) {
                            reject(new ClientError(message));
                        }
                        else {
                            reject(new ServerError(message));
                        }
                    }
                    else {
                        resolv();
                    }
                });
            });
        };
        /**
         * ### 確認コードを再度送る
         */
        Client.prototype.resendConfirmationCode = function (userName) {
            var userData = { Username: userName, Pool: this._userPool };
            var cognitoUser = new amazon_cognito_identity_js_1.CognitoUser(userData);
            return new Promise(function (resolv, reject) {
                cognitoUser.resendConfirmationCode(function (err) {
                    if (err) {
                        var message = "\u691C\u8A3C\u30B3\u30FC\u30C9\u306E\u518D\u767A\u884C\u304C\u3067\u304D\u307E\u305B\u3093\u3067\u3057\u305F\u3002( " + err + " )";
                        if (err.statusCode === 400) {
                            reject(new ClientError(message));
                        }
                        else {
                            reject(new ServerError(message));
                        }
                    }
                    else {
                        resolv();
                    }
                });
            });
        };
        /**
         * ### セッション作成に必要な情報の取得
         */
        Client.prototype.getEditData = function () {
            var _this = this;
            this._agent.request(URL['new']).
                then(function (res) {
                var resultSet = res.data['resultSet'];
                if (resultSet === undefined) {
                    throw _this.sessionResponseError('resultSet');
                }
                var links = resultSet.links;
                if (!Array.isArray(links) || links[0] === undefined) {
                    throw _this.sessionResponseError('links');
                }
                var headerSchema = links[0].headerSchema;
                if (headerSchema === undefined) {
                    throw _this.sessionResponseError('headerSchema');
                }
                var properties = headerSchema.properties;
                if (properties === undefined) {
                    throw _this.sessionResponseError('properties');
                }
                _this._headers = {};
                for (var key in properties) {
                    if (properties.hasOwnProperty(key)) {
                        _this._headers[key] = properties[key].enum[0];
                    }
                }
            }).catch(function (err) { return __awaiter(_this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (!(this._retry++ < this.retryMax))
                                return [3 /*break*/, 2];
                            return [4 /*yield*/, this.sleep()];
                        case 1:
                            _a.sent();
                            this.getEditData();
                            return [3 /*break*/, 3];
                        case 2:
                            if (err.response) {
                                this._errorMessage = 'サーバエラー: ' + err.response.data;
                                console.error({
                                    status: err.response.status,
                                    body: err.response.data,
                                });
                            }
                            else {
                                this._errorMessage = err.message;
                                console.log('Error', err.message);
                            }
                            _a.label = 3;
                        case 3: return [2 /*return*/];
                    }
                });
            }); });
        };
        /**
         * ### ユーザ認証
         * @param userName ユーザ名
         * @param password パスワード
         * @returns 次の処理に認証情報を渡すPromiseオブジェクトを返します
         */
        Client.prototype.authenticate = function (userName, password) {
            var authData = { Username: userName, Password: password };
            var authDetails = new amazon_cognito_identity_js_1.AuthenticationDetails(authData);
            var userData = { Username: userName, Pool: this._userPool };
            var cognitoUser = new amazon_cognito_identity_js_1.CognitoUser(userData);
            return new Promise(function (resolv, reject) {
                cognitoUser.authenticateUser(authDetails, {
                    onSuccess: function (result) { resolv(result); },
                    onFailure: function (err) {
                        if (err.statusCode === 400) {
                            reject(new AuthenticationError('Eメールアドレスかパスワードのどちらか、もしくはどちらも違います。'));
                        }
                        else {
                            reject(new ServerError('認証サーバに接続できませんでした。'));
                        }
                    },
                });
            });
        };
        /**
         * ### AdminAPIでセッションを生成する
         */
        Client.prototype.submit = function (userName, accessToken, idToken) {
            var _this = this;
            var session = {
                session: {
                    account: {
                        name: userName,
                        accessToken: accessToken,
                        idToken: idToken,
                    },
                },
            };
            return new Promise(function (resolv) {
                return _this._agent.request(Object.assign({}, URL['create'], { headers: _this._headers, data: session })).then(function (res) {
                    var resultSet = res.data['resultSet'];
                    if (resultSet === undefined) {
                        throw _this.sessionResponseError('resultSet');
                    }
                    if (resultSet.session === undefined) {
                        throw _this.sessionResponseError('session');
                    }
                    _this.save(resultSet.session);
                    // APIからユーザ名が取れるようになるまで仮に保存
                    _this.saveName(userName, new Date(resultSet.session['expiredAt']));
                    resolv();
                });
            });
        };
        /**
         * ### セッション情報をcookieに保存
         * @param session セッション情報
         */
        Client.prototype.save = function (session) {
            var _this = this;
            if (session['id'] === undefined) {
                throw this.sessionResponseError('session.id');
            }
            if (session['expiredAt'] === undefined) {
                throw this.sessionResponseError('session.expiredAt');
            }
            var sessionTokens = session['tokens'];
            if (!Array.isArray(sessionTokens) || sessionTokens.length < 1) {
                throw this.sessionResponseError('session.tokens');
            }
            var sessionExpires = new Date(session['expiredAt']);
            Cookie.set(SessionIdCookieName, session['id'], Object.assign({}, this._setting.cookie, { expires: sessionExpires }));
            var tokenExpires = null;
            var tokens = sessionTokens.map(function (token, i) {
                var tokenPath = 'tokens[' + i + ']';
                if (token['text'] === undefined) {
                    throw _this.sessionResponseError(tokenPath + '.text');
                }
                if (token['expiredAt'] === undefined) {
                    throw _this.sessionResponseError(tokenPath + '.expiredAt');
                }
                var apiKey = token['apiKey'];
                if (apiKey === undefined) {
                    throw _this.sessionResponseError(tokenPath + '.apiKey');
                }
                if (apiKey['text'] === undefined) {
                    throw _this.sessionResponseError(tokenPath + '.apiKey.text');
                }
                var organization = apiKey['organization'];
                if (organization === undefined) {
                    throw _this.sessionResponseError(tokenPath + '.apiKey.organization');
                }
                if (organization['id'] === undefined) {
                    throw _this.sessionResponseError(tokenPath + '.apiKey.organization.id');
                }
                var expires = new Date(token['expiredAt']);
                if (tokenExpires == null || expires < tokenExpires) {
                    tokenExpires = expires;
                }
                return {
                    token: token['text'],
                    apiKey: apiKey['text'],
                    organization_id: organization['id'],
                    metadata: apiKey['providerMetadata'],
                };
            });
            Cookie.set(SessionTokenCookieName, tokens, Object.assign({}, this._setting.cookie, { expires: tokenExpires }));
        };
        Client.prototype.sessionId = function () {
            return Cookie.get(SessionIdCookieName);
        };
        Client.prototype.sessionToken = function () {
            return Cookie.getJSON(SessionTokenCookieName);
        };
        /**
         * ### レスポンス構造についてのエラー
         */
        Client.prototype.sessionResponseError = function (key) {
            return new SessionError('サーバーエラー: レスポンスに"' + key + '"がありません。');
        };
        /**
         * ### リトライ回数に応じたインターバル設定
         * awaitと一緒に利用します。
         */
        Client.prototype.sleep = function () {
            var time = (Math.pow(2, this._retry)) * 500; // 2のリトライ回数乗✖0.5秒
            return new Promise(function (resolve) {
                setTimeout(function () { return resolve; }, time);
            });
        };
        /**
         * ### ユーザ名を保存する
         * 本当はCookieに保存せず、API経由でユーザ名を取得したいので
         * 将来的に不要になる関数
         */
        Client.prototype.saveName = function (name, expires) {
            Cookie.set(SessionUserNameCookieName, name, Object.assign(this._setting.cookie, { expires: expires }));
        };
        return Client;
    }());
    Session.Client = Client;
})(Session || (Session = {}));
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = Session;



//////////////////
// WEBPACK FOOTER
// ./build/js/session.js
// module id = 362
// module chunks = 0 1 2 3 4 6 7 8